import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const succeeded = searchParams.get("state") !== "cancel";

  useEffect(() => {
    if (succeeded) clearCart();
  }, [succeeded, clearCart]);

  return (
    <main className="successDiv" id="MainContent">
      <div className="success-container"><div className="modal-content">
        <div className="checkmark-circle"><FontAwesomeIcon icon={succeeded ? faCheck : faXmark} /></div>
        <h1>{succeeded ? "Payment successful" : "Payment cancelled"}</h1>
        <p>{succeeded ? "Thank you. Your order has been received and is being processed." : "No payment was completed. Your cart is still available if you would like to try again."}</p>
        <Link to={succeeded ? "/shop" : "/checkout"}>{succeeded ? "Continue shopping" : "Return to checkout"}</Link>
      </div></div>
    </main>
  );
};

export default PaySuccess;
